/*
 * @Description: 商城首页
 * @Author: ywj
 * @Date: 2025-01-22 09:45:29
 * @LastEditTime: 2025-08-13 17:12:51
 * @LastEditors: ywj@originqc.com
 */
import React, { useEffect, useState } from 'react'
import { Carousel, message } from 'antd';
import CustomTitle from '@/components/custom-title'
import GoodsMenu from '@/components/category-menu'
// import GoMore from '@/components/more'
// import Card from '@/components/card'
import CommonHead from '@/components/common-head'
// import { referData, computerData, goodsData, goodsData1, goodsLink } from './config'
// import cold from './imgs/cold.png'
import Goods from './components/goods';
import MiniGoods from './components/min-goods';
import HeadGoods from './components/head-goods'
import NoHeadGoods from './components/no-head-goods'
import DefaultFill from '@/components/default-fill'
import { getPropose, getCategory, getHomeGoods } from '@/api/home'
import {  openCustomerService } from '@/utils';
import useBackToTop from '@/hooks/useBackToTop';
import bg1 from './components/imgs/bg1.jpg';
import bg2 from './components/imgs/bg2.jpg';
import ServiceIds from '@/components/service-ids'

import './index.scss';
const numbersData = (length: number) => {
  return Array.from({ length }, (_, index) => index + 1);
};
// console.log(numbersData);
interface Product {
  type: string;
  // Add other properties if needed
}
const Home: React.FC = () => {
  const [proposeData, setProposeData] = useState<any>();//banner和推荐位数据
  // const [category, setCategory] = useState();
  const [homeGoods, setHomeGoods] = useState<any>();

  const [isLoading, setIsLoading] = useState(true); // 新增状态来管理加载状态
  const { scrollToTop } = useBackToTop(300); // 调用自定义 Hook

  useEffect(() => {
    handlePropose();
    // handleCategory();
    handleHomeGoods();
  }, []);
  useEffect(() => {
    scrollToTop();
  }, [])
  // const onChange = (currentSlide: number) => {

  // };
  //banner 和推荐位
  const handlePropose = async () => {
    try {
      const res = await getPropose();
      if (res.success) {


        setProposeData(res.obj);
      }
    } catch {

    } finally {
      setIsLoading(false);
    }
  }

  // // 全部分类
  // const handleCategory = async () => {
  //   try {
  //     const res = await getCategory();
  //     if (res.success) {
  //       console.log(res.obj);
  //       setCategory(res.obj.node);
  //     }
  //   } catch {

  //   } finally {
  //     setIsLoading(false);
  //   }
  // }

  // 全部商品
  const handleHomeGoods = async () => {
    try {
      const res = await getHomeGoods();
      if (res.success) {
        // console.log(res.obj,'onh');
        setHomeGoods(res.obj.node);
      }
    } catch {

    } finally {
      setIsLoading(false);
    }
  }

  const getComponent = (data: any) => {
    //  一、有子类：有tab ：1.有头图Goods
    //                   2.无头图 NoHeadGoods
    //   二、无子类：1.有有图 HeadGoods
    //              2.无头图 MiniGoods
    if (data.children.length > 0) { //有二级,展示children ,有tab
      //  有头图吗TODO，you头图，展示Goodss,没有头图展示MIniGoods,TODO:有二级菜单且没有头图的情况没考虑
      const dataP: any = [...data.children];
      const dataSoon: any = {
        type: 'more',
      };
      dataP?.map((item: any, index: number) => {
        if (item.products.length > 0) {
          if (item.products.length < 7) {
            // 只在products数组中添加一个 type: 'more' 项           
            const newProducts = [...item.products];
            if (!newProducts.some(product => product.type === 'more')) {
              newProducts.push(dataSoon);
            }
            item.products = newProducts;

          } else {
            // 直接在 item.products 上操作 ，特殊处理，大于8个时，显示8个，并且一半展示，一般浏览更多                          
            item.products = item.products.slice(0, 8);
            const eighthProduct = item.products[7] as Product;
            if (eighthProduct) {
              eighthProduct['type'] = 'more'
            }
          }
        }
      })
      if (data.mainProductName && data.serviceIds) {// 展示头图
        return <Goods goodsData={dataP} isTab='tab' data={data} />
      } else { //无头图
        return <NoHeadGoods goodsData={dataP} isTab='tab' data={data} />
      }

    } else { //没有二级,展示products,无tab
      if (data.products.length > 0) {
        if (data.products.length > 0 && data.products.length < 4) { // 不足一行，显示coming soon,数据插入coming soon
          const dataP = [...data.products];
          // const dataSoon: any = { //去掉敬请期待
          //   type: 'coming'
          // };
          // dataP.push(dataSoon);
          return <MiniGoods goodsData={dataP} data={data} />
        } else if (data.products.length === 4) { // 展示一行
          // console.log(data?.name, 'datass')
          const dataP = [...data.products];
          return <MiniGoods goodsData={dataP} data={data} />
        } else if (data.products.length >= 5 && data.products.length < 8) {  //展示2行,不足，数据插入coming soon 
          const dataP = [...data.products];
          // const dataSoon: any = {
          //   type: 'coming'
          // };
          // dataP.push(dataSoon);
          if (data.mainProductName && data.serviceIds) {// 展示头图,没有tab
            return <HeadGoods goodsData={dataP} isTab='more' data={data} />
          } else { //无头图 TODO:后期可能有头图，就去掉这部分的判断
            return <MiniGoods goodsData={dataP} data={data} />
          }
        } else {  //>=8展示2行，//超过8个，只展示8个
          const dataP = [...data.products];
          // const dataSoon: any = {
          //   type: 'coming'
          // };
          const processedData = [...dataP.slice(0, 8)];
          // if (['量子芯片及工艺设备', '稀释制冷机及配件', '量子计算测控系统'].includes(data.name)) {// 展示头图
          if (data.mainProductName && data.serviceIds) {// 展示头图
            return <HeadGoods goodsData={processedData} isTab='more' data={data} />
          } else { //无头图 TODO:后期可能有头图，就去掉这部分的判断
            return <MiniGoods goodsData={processedData} data={data} />
          }
        }
      }
    }
  }

  const handleCarousel = (item: any) => {
    if (item?.isLink) {
      window.open(item.link)
    } else { 
      window.open(`/detail?productSn=${item.productSn}`)
    }
    
  }

  const handleProposeDetail = (item: any) => {
    if (item?.isLink) {
      window.open(item.link)
    } else { 
      window.open(`/detail?productSn=${item.productSn}`)
    }
  }

  // 量子计算机跳转到详情
  const getDetail = (item: any) => {
    window.open(`/detail?productSn=${item?.productSn}`);

  }

  const handleService = (event: any) => {
    event?.stopPropagation();
    openCustomerService()
  }

  return (<>
    <CommonHead type='logo' />
    <div className='home-container'>
      <div className="home-content">
        <div className="home-box">
          <div className="carousel-box">
            {(isLoading || proposeData?.banner.length === 0 || !proposeData) ? (
              <DefaultFill width={1226} height={420} />
            ) : (<><Carousel
              // afterChange={onChange}
              autoplay={true}
              arrows={true}
            >
              {proposeData?.banner?.map((item: any, index: number) => {
                return (
                  <div key={index} className='banner-img' onClick={() => handleCarousel(item)}>
                    <img src={item.albumPics} alt="图片" />
                  </div>
                )
              })

              }
            </Carousel></>)}
            {!isLoading && homeGoods?.length > 0 && <div className="custom-menu-box">
              <GoodsMenu
                categoryData={homeGoods}
                bgColor={'rgba(125, 125, 125, 0.6)'}
              />
            </div>
            }
          </div>
          <div className="refer-content">
            {isLoading ?
              numbersData(4).map(number => {
                return (
                  <React.Fragment key={number}>
                    <DefaultFill width={296} height={160} />
                  </React.Fragment>

                )
              })
              :
              (() => {
                const proposeItems = proposeData?.propose?.map((item: any, index: number) => {
                  return (
                    <div className='refer-box' key={index} onClick={() => handleProposeDetail(item)}>
                      {/* <p className='refer-title'>{item.name}</p>
                      <p className='refer-subtitle'>{item?.serviceIds && getlinkString(item.serviceIds)}</p> */}
                      <img src={item.albumPics} alt="" />
                    </div>
                  )
                }) || [];

                const itemCount = proposeItems.length;
                if (itemCount < 4) {
                  const fillCount = 4 - itemCount;
                  for (let i = 0; i < fillCount; i++) {
                    proposeItems.push(<DefaultFill width={296} height={160} key={`fill-${i}`} />);
                  }
                }
                return proposeItems.length > 4 ? proposeItems.slice(0, 4) : proposeItems;
              })()
            }
          </div>
        </div>
      </div>
      <section className='home-goods-bg'>
        <div className='home-goods-box'>
          {proposeData?.propose.length === 5 && <div className="refer-five"
            onClick={() => handleProposeDetail(proposeData?.propose[4])}>
            {/* <div className="refer-five-left">
              <p className='refer-five-title'>{proposeData?.propose[4]?.name}</p>
              <p className='refer-five-subtitle'>{proposeData?.propose[4]?.serviceIds && getlinkString(proposeData?.propose[4].serviceIds)}</p>
            </div>
            <div className="refer-five-right"> */}
            <img src={proposeData?.propose[4].albumPics} alt="制冷机" />
            {/* </div> */}
          </div>}
          <div className="quantum-computer">
            {(isLoading || (Boolean(homeGoods) && homeGoods[0]!.products.length === 0)) ?
              <div className="conputer-box">
                {numbersData(2).map(number => {
                  return (
                    <React.Fragment key={number}>
                      <DefaultFill width={600} height={300} background={'#ffffff'} />
                    </React.Fragment>
                  )
                })}
              </div> :
              <><CustomTitle title={Boolean(homeGoods) && homeGoods[0]?.name} />
                <div className="conputer-box">
                  {Boolean(homeGoods) && homeGoods[0]!.products?.map((item: any, index: number) => {
                    return (
                      <div key={index} className='computer-item' onClick={() => getDetail(item)}>
                        <div className="img-box" style={{
                          background:
                            item.background == 'bg1.png' ? `url(${bg1}) no-repeat` :
                              (item.background == 'bg2.png' ? `url(${bg2}) no-repeat` : '')
                        }}>
                          <img src={item.albumPics} alt='计算机' />
                        </div>
                        <p className='computer-title'>{item.name}</p>
                        <span className='computer-subtitle'>
                          {/* {getlinkString(item.serviceIds).map((itm: string, index: number) => (
                            <React.Fragment key={index}>
                              <span className="service-id-item">{itm}</span>
                              {index < getlinkString(item.serviceIds).length - 1 && <span className="separator">|</span>}
                            </React.Fragment>))} */}
                            <ServiceIds serviceIds={item.serviceIds} />
                        </span>
                        <span className='consult'>{item.price ? <span>￥{item.price}</span> : <span onClick={(event) => handleService(event)}>立即咨询 {'>'}</span>}</span>
                      </div>
                    )
                  })}
                </div>
              </>
            }
          </div>
          {Boolean(homeGoods) && homeGoods.slice(1)?.map((childrenItem: any, index: number) => {
            return (
              <>{getComponent(childrenItem)}</>
            )
          })}
          {/* <Goods title={'量子芯片及工艺设备'} type='more' goodsData={goodsData} />
          <Goods title={'稀释制冷机及配件'} type='more' goodsData={goodsData} />
          <Goods title={'量子计算测控系统'} type='tab' goodsData={goodsData1} /> */}
          {/* 没有二级，小于4 */}
          {/* <MiniGoods/> */}
          {/* <section className='goods-chain'>
            <div className="goods-top">
              <CustomTitle title={'量子测控链路'} /><GoMore />
            </div>
            <div className="card-box">
              {goodsLink.map(item => {
                return (
                  <Card {...item} width={295} />
                )
              })}
            </div>
          </section> */}
          {/* <section className='goods-chain'>
            <div className="goods-top">
              <CustomTitle title={'量子测控链路'} /><GoMore />
            </div>
            <div className="card-box">
              {goodsLink.map(item => {
                return (
                  <Card {...item} width={295} />
                )
              })}
            </div>
          </section> */}
          {/* <MiniGoods/> */}
          {/* <section className='goods-chain'>
            <div className="goods-top">
              <CustomTitle title={'量子测控链路'} /><GoMore />
            </div>
            <div className="card-box">
              {goodsLink.map(item => {
                return (
                  <Card {...item} width={295} />
                )
              })}
            </div>
          </section> */}
        </div>
      </section>

    </div>
  </>

  )
}

export default Home;